import { render, staticRenderFns } from "./ArticlesOfAgreement_en.vue?vue&type=template&id=1cc5c236&scoped=true"
import script from "./ArticlesOfAgreement_en.vue?vue&type=script&lang=js"
export * from "./ArticlesOfAgreement_en.vue?vue&type=script&lang=js"
import style0 from "./ArticlesOfAgreement_en.vue?vue&type=style&index=0&id=1cc5c236&prod&lang=scss&rel=text%2Fcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_a0b2c34ca8cb6aec36211e2e48fb208b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc5c236",
  null
  
)

export default component.exports